import { render, staticRenderFns } from "./s3Uploader.vue?vue&type=template&id=4cbdbd68&scoped=true"
import script from "./s3Uploader.vue?vue&type=script&lang=ts"
export * from "./s3Uploader.vue?vue&type=script&lang=ts"
import style0 from "./s3Uploader.vue?vue&type=style&index=0&id=4cbdbd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbdbd68",
  null
  
)

export default component.exports